'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

require('styles/theme.scss');

require('styles/theme.scss.liquid');

var _themeA11y = require('@shopify/theme-a11y');

var _Accordions = require('components/Accordions');

var _Overlay = require('components/Overlay');

var _Navigation = require('components/Navigation');

var _Lazyload = require('components/Lazyload');

var _Sliders = require('components/Sliders');

var _Cart = require('components/Cart');

var _MailChimpModal = require('components/MailChimpModal');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Common a11y fixes
(0, _themeA11y.focusHash)();
(0, _themeA11y.bindInPageLinks)();

document.addEventListener('DOMContentLoaded', (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
  return _regenerator2.default.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          (0, _Overlay.init)();
          (0, _Navigation.init)();
          (0, _Lazyload.init)();
          (0, _Sliders.init)();
          (0, _Cart.init)();
          (0, _Accordions.init)();
          (0, _MailChimpModal.init)();

        case 7:
        case 'end':
          return _context.stop();
      }
    }
  }, _callee, undefined);
})));

// HMR
// if (module.hot) {
//   module.hot.accept();
// }

// if (module.hot) {
//   module.hot.dispose(() => {
//     // reset/undo the behavior/side effect that as possibly enabled/enacted

//   });
// }